import React, { useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import InlineHelpText from '../../shared/InlineHelpText';
import HelpIcon from '../../shared/HelpIcon';
import SvgXIcon from '../../svg/XIcon';
import {
  deviceDescriptionText,
  deviceIdText,
  editText,
  notesText,
} from '../../shared/SharedInternationalizations';
import SvgCheckMarkIcon from '../../svg/CheckMarkIcon';
import AccessControl from '../../../AccessControl';
import permissions from '../../../permissionsList';

export function AlertPhoneDisplay(props) {
  const {
    retry_after_noans,
    retry_after_msg,
    retry_cnt,
    retry_interval,
    notify_on_clear,
    interface_name,
    notes,
    alert_device_id,
    alert_description,
    alert_device_type,
    alert_device_category,
    phone_number,
  } = props.deviceDetails;
  const {
    assignedInfo,
    deviceType,
    assignedGroupNames,
    alertCategoryName,
    previous,
    'data-test': dataTest,
  } = props;

  const [
    showCallIfVoicemailHelpText,
    setShowCallIfVoicemailHelpText,
  ] = useState(false);
  function toggleShowCallIfVoicemailHelpText(value) {
    setShowCallIfVoicemailHelpText(value);
  }
  const callIfVoicemailHelpTextRef = useRef();
  const callIfVoicemailHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.callIfVoicemailHelpText"
      defaultMessage="If SARA calls this phone number and the call goes to voicemail, the system will attempt to call the number again."
    />
  );
  const [showCallIfNoAnswerHelpText, setShowCallIfNoAnswerHelpText] = useState(
    false
  );
  function toggleShowCallIfNoAnswerHelpText(value) {
    setShowCallIfNoAnswerHelpText(value);
  }
  const callIfNoAnswerHelpTextRef = useRef();
  const callIfNoAnswerHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.callIfNoAnswerHelpText"
      defaultMessage="If SARA calls this phone number and the call is not answered, the system will attempt to call the number again."
    />
  );
  const [showCallAttemptsHelpText, setShowCallAttemptsHelpText] = useState(
    false
  );
  function toggleShowCallAttemptsHelpText(value) {
    setShowCallAttemptsHelpText(value);
  }
  const callAttemptsHelpTextRef = useRef();
  const callAttemptsHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.callAttemptsHelpText"
      defaultMessage="If SARA calls this phone number and the call is not answered, this is the number of times the system will attempt to call the number again."
    />
  );
  const [
    showCallAttemptsWaitHelpText,
    setShowCallAttemptsWaitHelpText,
  ] = useState(false);
  function toggleShowCallAttemptsWaitHelpText(value) {
    setShowCallAttemptsWaitHelpText(value);
  }
  const callAttemptsWaitHelpTextRef = useRef();
  const callAttemptsWaitHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.callAttemptsWaitHelpText"
      defaultMessage="If SARA calls this phone number and the call is not answered, this is the number of times the system will attempt to call the number again."
    />
  );
  const [showCallInterfaceHelpText, setShowCallInterfaceHelpText] = useState(
    false
  );
  function toggleShowCallInterfaceHelpText(value) {
    setShowCallInterfaceHelpText(value);
  }
  const callInterfaceHelpTextRef = useRef();
  const callInterfaceHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.callInterfaceHelpText"
      defaultMessage="SARA will only call this interface."
    />
  );
  const [
    showNotifyWhenClearedHelpText,
    setShowNotifyWhenClearedHelpText,
  ] = useState(false);
  function toggleShowNotifyWhenClearedHelpText(value) {
    setShowNotifyWhenClearedHelpText(value);
  }
  const notifyWhenClearedHelpTextRef = useRef();
  const notifyWhenClearedHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.notifyWhenClearedHelpText"
      defaultMessage="When an alert is cleared, this will get notified."
    />
  );
  const [showNotesHelpText, setShowNotesHelpText] = useState(false);
  function toggleShowNotesHelpText(value) {
    setShowNotesHelpText(value);
  }
  const notesHelpTextRef = useRef();
  const notesHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.notesHelpText"
      defaultMessage="Notes for this device."
    />
  );
  const [showDescriptionHelpText, setShowDescriptionHelpText] = useState(false);
  function toggleShowDescriptionHelpText(value) {
    setShowDescriptionHelpText(value);
  }
  const descriptionHelpTextRef = useRef();
  const descriptionHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.descriptionHelpText"
      defaultMessage="The description for this device."
    />
  );
  const [showDeviceIdHelpText, setShowDeviceIdHelpText] = useState(false);
  function toggleShowDeviceIdHelpText(value) {
    setShowDeviceIdHelpText(value);
  }
  const deviceIdHelpTextRef = useRef();
  const deviceIdHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.deviceIdHelpText"
      defaultMessage="This is the device's Id."
    />
  );
  const [showDeviceTypeHelpText, setShowDeviceTypeHelpText] = useState(false);
  function toggleShowDeviceTypeHelpText(value) {
    setShowDeviceTypeHelpText(value);
  }
  const deviceTypeHelpTextRef = useRef();
  const deviceTypeHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.deviceTypeHelpText"
      defaultMessage="This is the assigned type for this device."
    />
  );
  const [showAlertCategoryHelpText, setShowAlertCategoryHelpText] = useState(
    false
  );
  function toggleShowAlertCategoryHelpText(value) {
    setShowAlertCategoryHelpText(value);
  }
  const alertCategoryHelpTextRef = useRef();
  const alertCategoryHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.alertCategoryHelpText"
      defaultMessage="This isthe alert category that this device is assigned to."
    />
  );
  const [showAlertGroupsHelpText, setShowAlertGroupsHelpText] = useState(false);
  function toggleShowAlertGroupsHelpText(value) {
    setShowAlertGroupsHelpText(value);
  }
  const alertGroupsHelpTextRef = useRef();
  const alertGroupsHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.alertGroupsHelpText"
      defaultMessage="These are alert groups that this device is assigned to."
    />
  );
  const [
    showDeviceAssignmentHelpText,
    setShowDeviceAssignmentHelpText,
  ] = useState(false);
  function toggleShowDeviceAssignmentHelpText(value) {
    setShowDeviceAssignmentHelpText(value);
  }
  const deviceAssignmentHelpTextRef = useRef();
  const deviceAssignmentHelpText = (
    <FormattedMessage
      id="AlertPhoneDisplay.deviceAssignmentHelpText"
      defaultMessage="This is the assignment for this device. The device can be assigned to a user or a unit."
    />
  );

  return (
    <div data-test={dataTest}>
      <div className="content-display__container content-display__container--column align-center">
        <FormattedMessage
          id="AlertPhoneDisplay.addAlertPhoneTitle"
          data-test="header-text"
          defaultMessage="View Alert Details for Phone Number: {device}"
          description="The title for the page to edit a unit"
          values={{
            device: phone_number,
          }}>
          {(txt) => (
            <h1
              className="no-margin text-deep-blue text-center"
              data-test="header-text-device">
              {txt}
            </h1>
          )}
        </FormattedMessage>

        <hr />
      </div>
      <div className="content-display__container" data-test="content-container">
        <div className="content-display__column content-display__column--1-2">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                <FormattedMessage
                  id="AlertPhoneDisplay.deviceAssignment"
                  defaultMessage="Device Assigned To"
                  description="This alert phone number is assigned to:"
                  data-test="assigned-to-text"
                />
              </div>
              <div className="item-container__secondary-text text-medium text-bold">
                {assignedInfo.length > 0 ? assignedInfo : ''}
              </div>
            </div>

            <div className="item-container__info-container">
              <HelpIcon
                onClick={() =>
                  deviceAssignmentHelpTextRef.current.toggleHelpText()
                }
                toggled={showDeviceAssignmentHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={deviceAssignmentHelpTextRef}
            toggleFunction={toggleShowDeviceAssignmentHelpText}
            message={deviceAssignmentHelpText}
          />
        </div>
        <div className="content-display__column content-display__column--1-2">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                <FormattedMessage
                  id="AlertPhoneDisplay.deviceType"
                  defaultMessage="Device Type"
                  description="This alert phone number is assigned to:"
                  data-test="device-type-text"
                />
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="device-type-container">
                {deviceType}
              </div>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => deviceTypeHelpTextRef.current.toggleHelpText()}
                toggled={showDeviceTypeHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={deviceTypeHelpTextRef}
            toggleFunction={toggleShowDeviceTypeHelpText}
            message={deviceTypeHelpText}
          />
        </div>

        <div className="content-display__column content-display__column--1-2">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                {deviceDescriptionText}
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="alert-description-container">
                {alert_description}
              </div>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => descriptionHelpTextRef.current.toggleHelpText()}
                toggled={showDescriptionHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={descriptionHelpTextRef}
            toggleFunction={toggleShowDescriptionHelpText}
            message={descriptionHelpText}
          />
        </div>
        <div className="content-display__column content-display__column--1-2">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                {deviceIdText}
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="alert-device-id-container">
                {alert_device_id}
              </div>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => deviceIdHelpTextRef.current.toggleHelpText()}
                toggled={showDeviceIdHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={deviceIdHelpTextRef}
            toggleFunction={toggleShowDeviceIdHelpText}
            message={deviceIdHelpText}
          />
        </div>

        {interface_name ? (
          <div
            className="content-display__column content-display__column--1-2"
            data-test="interface-name-container">
            <div className="content-display__item-pill-container">
              <div className="item-container__main-container">
                <div className="item-container__main-text text-large text-light">
                  <FormattedMessage
                    id="AlertPhoneDisplay.callInterface"
                    defaultMessage="Calls will be restricted to this interface:"
                    description="This device will receive check-in report emails"
                    data-test="interface"
                  />
                </div>
                <div
                  className="item-container__secondary-text text-medium text-bold"
                  data-test="interface-name-text-container">
                  {interface_name}
                </div>
              </div>
              <div className="item-container__info-container">
                <HelpIcon
                  onClick={() =>
                    callInterfaceHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showCallInterfaceHelpText}
                />
              </div>
            </div>
            <InlineHelpText
              ref={callInterfaceHelpTextRef}
              toggleFunction={toggleShowCallInterfaceHelpText}
              message={callInterfaceHelpText}
            />
          </div>
        ) : (
          ''
        )}

        {notes ? (
          <div
            className="content-display__column content-display__column--1-2"
            data-test="notes-container">
            <div className="content-display__item-pill-container">
              <div className="item-container__main-container">
                <div className="item-container__main-text text-large text-light">
                  {notesText}
                </div>
                <div
                  className="item-container__secondary-text text-medium text-bold"
                  data-test="notes-text-container">
                  {notes}
                </div>
              </div>
              <div className="item-container__info-container">
                <HelpIcon
                  onClick={() => notesHelpTextRef.current.toggleHelpText()}
                  toggled={showNotesHelpText}
                />
              </div>
            </div>
            <InlineHelpText
              ref={notesHelpTextRef}
              toggleFunction={toggleShowNotesHelpText}
              message={notesHelpText}
            />
          </div>
        ) : (
          ''
        )}
        <div
          className="content-display__column content-display__column--1-2"
          data-test="retry-after-no-answer-container">
          <div className="content-display__item-pill-container">
            {retry_after_noans ? (
              <React.Fragment>
                <div className="item-container__info-container">
                  <SvgCheckMarkIcon className="text-success" />
                </div>
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertPhoneDisplay.callAfterNoAnswerTrueText"
                      defaultMessage="SARA <b>will</b> call this device back if the call is not answered"
                      description="This user will receive check-in report emails"
                      data-test="call-after-no-answer-true"
                      values={{
                        b: (msg) => (
                          <span className="item-container__text-highlighted">
                            {msg}
                          </span>
                        ),
                      }}
                    />
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="item-container__info-container">
                  <SvgXIcon className="text-alert" />
                </div>
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertPhoneDisplay.callAfterNoAnswerFalseText"
                      defaultMessage="SARA <b>will not</b> call this device back if the call is not answered"
                      description="This user will receive check-in report emails"
                      data-test="call-after-no-answer-false"
                      values={{
                        b: (msg) => (
                          <span className="item-container__text-highlighted item-container__text-highlighted--alert">
                            {msg}
                          </span>
                        ),
                      }}
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() =>
                  callIfNoAnswerHelpTextRef.current.toggleHelpText()
                }
                toggled={showCallIfNoAnswerHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={callIfNoAnswerHelpTextRef}
            toggleFunction={toggleShowCallIfNoAnswerHelpText}
            message={callIfNoAnswerHelpText}
          />
        </div>
        <div
          className="content-display__column content-display__column--1-2"
          data-test="retry-after-message-container">
          <div className="content-display__item-pill-container">
            {retry_after_msg ? (
              <React.Fragment>
                <div className="item-container__main-container">
                  <div className="item-container__info-container">
                    <SvgCheckMarkIcon className="text-success" />
                  </div>
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertPhoneDisplay.callAfterMessageTrueText"
                      defaultMessage="SARA <b>will</b> call this device back if the call goes to voicemail"
                      description="This user  will receive check-in report emails"
                      data-test="call-after-message-true"
                      values={{
                        b: (msg) => (
                          <span className="item-container__text-highlighted">
                            {msg}
                          </span>
                        ),
                      }}
                    />
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="item-container__info-container">
                  <SvgXIcon className="text-alert" />
                </div>
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertPhoneDisplay.callAfterMessageFalseText"
                      defaultMessage="SARA <b>will not</b> call this device back if the call goes to voicemail"
                      description="This user will receive check-in report emails"
                      data-test="call-after-message-false"
                      values={{
                        b: (msg) => (
                          <span className="item-container__text-highlighted item-container__text-highlighted--alert">
                            {msg}
                          </span>
                        ),
                      }}
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() =>
                  callIfVoicemailHelpTextRef.current.toggleHelpText()
                }
                toggled={showCallIfVoicemailHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={callIfVoicemailHelpTextRef}
            toggleFunction={toggleShowCallIfVoicemailHelpText}
            message={callIfVoicemailHelpText}
          />
        </div>

        {retry_after_noans || retry_after_msg ? (
          <React.Fragment>
            <div className="content-display__column content-display__column--1-2">
              <div className="content-display__item-pill-container">
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertPhoneDisplay.retryNoAnswerNumber"
                      defaultMessage="SARA will call this device {number} times if there is no answer."
                      description="This user will receive check-in report emails"
                      data-test="call-retry-number"
                      values={{
                        number: (
                          <span className="item-container__text-highlighted">
                            {retry_cnt}
                          </span>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className="item-container__info-container">
                  <HelpIcon
                    onClick={() =>
                      callAttemptsHelpTextRef.current.toggleHelpText()
                    }
                    toggled={showCallAttemptsHelpText}
                  />
                </div>
              </div>
              <InlineHelpText
                ref={callAttemptsHelpTextRef}
                toggleFunction={toggleShowCallAttemptsHelpText}
                message={callAttemptsHelpText}
              />
            </div>
            <div className="content-display__column content-display__column--1-2">
              <div className="content-display__item-pill-container">
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertPhoneDisplay.retryIntervalText"
                      defaultMessage={`SARA will wait {number} minutes between calls.`}
                      description="This user will receive check-in report emails"
                      data-test="call-retry-interval"
                      values={{
                        number: (
                          <span className="item-container__text-highlighted">
                            {retry_interval}
                          </span>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className="item-container__info-container">
                  <HelpIcon
                    onClick={() =>
                      callAttemptsWaitHelpTextRef.current.toggleHelpText()
                    }
                    toggled={showCallAttemptsWaitHelpText}
                  />
                </div>
              </div>
              <InlineHelpText
                ref={callAttemptsWaitHelpTextRef}
                toggleFunction={toggleShowCallAttemptsWaitHelpText}
                message={callAttemptsWaitHelpText}
              />
            </div>
          </React.Fragment>
        ) : (
          ''
        )}
        {alert_device_type === 3 ? (
          <div
            className="content-display__column content-display__column--1-2"
            data-test="alert-when-cleared-container">
            <div className="content-display__item-pill-container">
              {notify_on_clear ? (
                <React.Fragment>
                  <div className="item-container__info-container">
                    <SvgCheckMarkIcon className="text-success" />
                  </div>

                  <div className="item-container__main-container">
                    <div className="item-container__main-text text-large text-light">
                      <FormattedMessage
                        id="AlertPhoneDisplay.notifyOnClearTrueText"
                        defaultMessage="SARA <b>will</b> send this device a message when an alarm is cleared."
                        description="This user <b>will</b> receive check-in report emails"
                        data-test="alert-when-cleared-true"
                        values={{
                          b: (msg) => (
                            <span className="item-container__text-highlighted">
                              {msg}
                            </span>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="item-container__info-container">
                    <SvgXIcon className="text-alert" />
                  </div>
                  <div className="item-container__main-container">
                    <div className="item-container__main-text text-large text-light">
                      <FormattedMessage
                        id="AlertPhoneDisplay.notifyOnClearFalseText"
                        defaultMessage="SARA <b>will not</b> send this device a message when an alarm is cleared."
                        description="This user will receive check-in report emails"
                        data-test="alert-when-cleared-false"
                        values={{
                          b: (msg) => (
                            <span className="item-container__text-highlighted item-container__text-highlighted--alert">
                              {msg}
                            </span>
                          ),
                        }}
                      />
                    </div>
                    <div className="item-container__secondary-text text-medium"></div>
                  </div>
                </React.Fragment>
              )}
              <div className="item-container__info-container">
                <HelpIcon
                  onClick={() =>
                    notifyWhenClearedHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showNotifyWhenClearedHelpText}
                />
              </div>
            </div>
            <InlineHelpText
              ref={notifyWhenClearedHelpTextRef}
              toggleFunction={toggleShowNotifyWhenClearedHelpText}
              message={notifyWhenClearedHelpText}
            />
          </div>
        ) : (
          ''
        )}

        <div
          className="content-display__column content-display__column--1-2"
          data-test="assigned-groups-container">
          <div className="content-display__item-pill-container">
            {assignedGroupNames.length > 0 ? (
              <React.Fragment>
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertPhoneDisplay.alertGroupsText"
                      defaultMessage="Alert Groups"
                      description="This user will receive check-in report emails"
                      data-test="assigned-alert-groups"
                    />
                  </div>
                  <div className="item-container__secondary-text text-medium text-bold">
                    {assignedGroupNames.map((group, index) => (
                      <div className="" key={index}>
                        {group}
                      </div>
                    ))}
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="item-container__info-container">
                  <SvgXIcon className="text-alert" />
                </div>
                <div className="item-container__main-container vertical-center">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertPhoneDisplay.notAssignedToAlertGroups"
                      defaultMessage="This device is <b>not</b> assigned to any alert groups"
                      description="This user  will receive check-in report emails"
                      data-test="not-assigned-alert-groups"
                      values={{
                        b: (msg) => (
                          <span className="item-container__text-highlighted item-container__text-highlighted--alert">
                            {msg}
                          </span>
                        ),
                      }}
                    />
                  </div>
                  <div className="item-container__secondary-text text-medium"></div>
                </div>
              </React.Fragment>
            )}
            <AccessControl
              data-test="access-control"
              feature={permissions.static.devices.alert.editAlertDevice}>
              <div className="item-container__info-container">
                <Link
                  data-test="associate-alert-group-link"
                  to={{
                    pathname: `/devices/alert/${alert_device_id}/edit/`,
                    search: '?mode=associateAlertGroup',
                    state: {
                      modal: true,
                      previous: previous,
                    },
                  }}
                  className="link-button button-secondary button-xsm text-small margin-right-10">
                  <FormattedMessage
                    id="alertPhoneDisplay.quickEditUnitsText"
                    defaultMessage="Edit Alert Groups"
                    description="A link to open the interface to edit the units assigned to this user"
                  />
                </Link>
                <HelpIcon
                  onClick={() =>
                    alertGroupsHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showAlertGroupsHelpText}
                />
              </div>
            </AccessControl>
          </div>

          <InlineHelpText
            ref={alertGroupsHelpTextRef}
            toggleFunction={toggleShowAlertGroupsHelpText}
            message={alertGroupsHelpText}
          />
        </div>

        {alert_device_type === 3 ? (
          <div
            className="content-display__column content-display__column--1-2"
            data-test="alert-category-container">
            {alert_device_category ? (
              <div className="content-display__item-pill-container">
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertPhoneDisplay.alertCategoryText"
                      defaultMessage="Alert Category"
                      description="This user will receive check-in report emails"
                      data-test="alert-category-text"
                    />
                  </div>
                  <div className="item-container__secondary-text text-medium text-bold">
                    {alertCategoryName}
                  </div>
                </div>
                <div className="item-container__info-container">
                  <HelpIcon
                    onClick={() =>
                      alertCategoryHelpTextRef.current.toggleHelpText()
                    }
                    toggled={showAlertCategoryHelpText}
                  />
                </div>
              </div>
            ) : (
              <div className="content-display__item-pill-container">
                <div className="item-container__info-container">
                  <SvgXIcon className="text-alert" />
                </div>
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertPhoneDisplay.notAssignedToAlertCategory"
                      defaultMessage="This device is <b>not</b> assigned to an alert category"
                      description="This user  will receive check-in report emails"
                      data-test="alert-category-false"
                      values={{
                        b: (msg) => (
                          <span className="item-container__text-highlighted item-container__text-highlighted--alert">
                            {msg}
                          </span>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className="item-container__info-container">
                  <HelpIcon
                    onClick={() =>
                      alertCategoryHelpTextRef.current.toggleHelpText()
                    }
                    toggled={showAlertCategoryHelpText}
                  />
                </div>
              </div>
            )}

            <InlineHelpText
              ref={alertCategoryHelpTextRef}
              toggleFunction={toggleShowAlertCategoryHelpText}
              message={alertCategoryHelpText}
            />
          </div>
        ) : (
          ''
        )}
      </div>
      <AccessControl
        data-test="access-control"
        feature={permissions.static.devices.alert.editAlertDevice}>
        <div className="width-100 align-center flex-end">
          <Link
            data-test="edit-alert-phone-link"
            className="link-button button-secondary button-sm text-small margin-left-10"
            to={{
              pathname: `/devices/alert/${alert_device_id}/edit/`,
              state: {
                modal: true,
                previous: props.previous,
              },
            }}>
            {editText}
          </Link>
        </div>
      </AccessControl>
    </div>
  );
}

export default AlertPhoneDisplay;
